/**
 * Footer Component
 * Shows business info and powered by Mangoes Unified
 */

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SiteThoughts } from 'shared-ui';
import { usePortal } from '../context/PortalContext';
import { getApiBaseUrl } from '../services/api';
import { pageNameFor } from '../config/pageNames';

// These two pages already end with their own thoughts cards.
const HAS_OWN_THOUGHTS = ['/presentation', '/dashboard'];

const Footer = () => {
  const { branding, isSectionVisible, businessId } = usePortal();
  const { pathname } = useLocation();

  return (
    <>
    {/* "Record your thoughts" on every page, for a prospect who has their access code (Zee,
        2026-09-28). Renders nothing for the public. */}
    {!HAS_OWN_THOUGHTS.includes(pathname) && (
      <SiteThoughts apiBaseUrl={getApiBaseUrl()} businessId={businessId} pageName={pageNameFor(pathname)} />
    )}
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div className="grid grid-3" style={styles.grid}>
          {/* Business Info */}
          <div>
            <h3 style={{ ...styles.title, color: branding.primaryColor }}>
              {branding.businessName}
            </h3>
            <p style={styles.text}>
              Thank you for visiting. We look forward to serving you.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={styles.subtitle}>Quick Links</h4>
            <nav style={styles.linkList}>
              <Link to="/" style={styles.link}>Home</Link>
              {isSectionVisible('products') && <Link to="/products" style={styles.link}>Products</Link>}
              {isSectionVisible('services') && <Link to="/services" style={styles.link}>Services</Link>}
              {isSectionVisible('about') && <Link to="/about" style={styles.link}>About</Link>}
              {isSectionVisible('contact') && <Link to="/contact" style={styles.link}>Contact</Link>}
            </nav>
          </div>

          {/* Contact */}
          {isSectionVisible('contact') && (
            <div>
              <h4 style={styles.subtitle}>Contact</h4>
              <p style={styles.text}>Get in touch with us</p>
              <Link to="/contact" style={{ ...styles.link, color: branding.primaryColor }}>
                Send a message →
              </Link>
            </div>
          )}
        </div>

        {/* Bottom Bar */}
        <div style={styles.bottom}>
          <p style={styles.copyright}>
            © {new Date().getFullYear()} {branding.businessName}. All rights reserved.
          </p>
          <p style={styles.poweredBy}>
            Powered by <a href="https://mango-business.solutions" style={styles.mangoLink}>Mangoes Unified</a>
          </p>
        </div>
      </div>
    </footer>
    </>
  );
};

const styles = {
  footer: {
    background: '#1a1a2e',
    color: 'white',
    padding: '60px 0 30px',
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
  },
  grid: {
    marginBottom: '40px',
  },
  title: {
    fontSize: '1.5rem',
    marginBottom: '15px',
  },
  subtitle: {
    fontSize: '1.1rem',
    marginBottom: '15px',
    color: 'white',
  },
  text: {
    color: '#aaa',
    lineHeight: '1.6',
  },
  linkList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  link: {
    color: '#aaa',
    textDecoration: 'none',
    transition: 'color 0.3s',
  },
  bottom: {
    borderTop: '1px solid #333',
    paddingTop: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '20px',
  },
  copyright: {
    color: '#666',
    fontSize: '0.9rem',
  },
  poweredBy: {
    color: '#666',
    fontSize: '0.9rem',
  },
  mangoLink: {
    color: '#FFA500',
    textDecoration: 'none',
  },
};

export default Footer;
